import { useState } from 'react'
import { Typography } from '@mui/material'
import TokTokDocDialog from '../PlannedExpertiseDeleteDialog/../../Common/Dialog'
import { useAppDispatch } from '../../../store'
import { displaySnackbar } from '../../../actions/main'
import { DeleteBackgroundIcon } from '../../../assets/icons/icons'
import useCurrentHcs from '../../../hooks/useCurrentHcs'
import {
    useDeleteIdsHealthcareservicesHcsIdTransmissionsTransmissionId,
} from '@toktokdoctech/tokapi-client'
import useStyles from './_styles'
import { PlannedExpertiseDeleteDialogProps } from './_props'
import { tanstackQueryClient } from '../../../api/tanstackClient'

const PlannedExpertiseDeleteDialog = ({
    isOpen,
    plannedExpertiseId,
    onClose,
}: PlannedExpertiseDeleteDialogProps) => {
    const dispatch = useAppDispatch()
    const [isDeletionLoading, setIsDeletionLoading] = useState(false)
    const classes = useStyles()
    const currentHcs = useCurrentHcs()
    const { mutateAsync: deleteTransmission, isPending: isDeletingTransmission } = useDeleteIdsHealthcareservicesHcsIdTransmissionsTransmissionId()

    const handleDelete = async () => {
        setIsDeletionLoading(true)
        try {
            if (!currentHcs?.id) {
                throw new Error('HCS introuvable')
            }
            if (!plannedExpertiseId) {
                throw new Error('ID téléexpertise introuvable')
            }
            await deleteTransmission({
                hcsId: currentHcs.id,
                transmissionId: plannedExpertiseId,
            })
            await tanstackQueryClient.refetchQueries({
                queryKey: [`/ids/healthcareservices/${currentHcs.id}/transmissions`],
                exact: false,
            })
            dispatch(
                displaySnackbar(
                    'success',
                    'La téléexpertise a bien été supprimée',
                    undefined,
                    `[PlannedExpertiseDeleteDialog] suppression téléexpertise ${plannedExpertiseId ?? ''}`,
                ),
            )
            onClose()
        } catch (error: any) {
            dispatch(
                displaySnackbar(
                    'error',
                    error?.message ?? 'Une erreur est survenue pendant la suppression de la téléexpertise',
                    undefined,
                    `[PlannedExpertiseDeleteDialog] error suppression téléexpertise ${plannedExpertiseId ?? ''}`,
                ),
            )
        } finally {
            setIsDeletionLoading(false)
        }
    }

    return (
        <TokTokDocDialog
            isOpen={isOpen}
            handleClose={onClose}
            handleSave={handleDelete}
            handleCancel={onClose}
            saveTitle="Supprimer"
            title="Êtes-vous sûr de supprimer la téléexpertise ?"
            loading={isDeletionLoading}
            disableEscape={false}
            isDeleteAction
            dialogProps={{
                fullScreen: false,
                PaperProps: {
                    className: classes.dialogPaperNoScroll,
                    style: { overflow: 'hidden' },
                },
                slotProps: {
                    backdrop: {
                        className: classes.PlannedExpertisePopUpDeleteBackdrop,
                    },
                },
            }}
        >
            <Typography className={classes.PlannedExpertisePopUpDelete}>
                En poursuivant, la téléexpertise sera définitivement supprimée
            </Typography>
            <DeleteBackgroundIcon />
        </TokTokDocDialog>
    )
}

export default PlannedExpertiseDeleteDialog

